import { render, staticRenderFns } from "./ImportBookings.vue?vue&type=template&id=c2e47cc4&scoped=true&"
import script from "./ImportBookings.vue?vue&type=script&lang=js&"
export * from "./ImportBookings.vue?vue&type=script&lang=js&"
import style0 from "./ImportBookings.vue?vue&type=style&index=0&id=c2e47cc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e47cc4",
  null
  
)

export default component.exports